// window.googleConfig is loaded from public/config.js at runtime.
const config = window.googleConfig;

export const googleConfig = config?.clientId ? config : null;

const GOOGLE_AUTH_ENDPOINT = "https://accounts.google.com/o/oauth2/v2/auth";

export const GOOGLE_STATE_STORAGE_KEY = "googleAuthState";

export const createRandomToken = () =>
  window.crypto?.randomUUID
    ? window.crypto.randomUUID().replace(/-/g, "")
    : `${Date.now()}${Math.random().toString(36).slice(2)}`;

// OIDC implicit flow: Google returns the id_token in the URL fragment, so no client secret is needed.
export const buildGoogleAuthUrl = ({ nonce, state, tenantConfiguration }) => {
  if (!tenantConfiguration) return null;

  const params = new URLSearchParams({
    client_id: tenantConfiguration.AppClientId,
    redirect_uri: googleConfig.redirectUri,
    response_type: "id_token",
    response_mode: "fragment",
    scope: (googleConfig.scopes || ["openid", "profile", "email"]).join(" "),
    nonce,
    state,
    prompt: "select_account",
  });

  return `${GOOGLE_AUTH_ENDPOINT}?${params.toString()}`;
};
